module.exports = __webpack_public_path__ + "img/banner.689ae73b.jpg";